module.exports = __webpack_public_path__ + "static/media/biteship-via-mobile-app.b20c2228.png";